import React, { useState } from 'react';
import './ImageDecoder.scss';

// Le immagini arrivano da Cantaloupe via IIIF (/iiif/2/<picture_id>), non
// piu in base64 dentro il JSON dell'opera: una scheda con tre foto pesava
// fino a 6 MB e superava il timeout di 20 s di axios sulle connessioni
// lente. Stesso schema gia usato da ArtworkListItem e MapDetailCard.
//
// !w,h chiede a Cantaloupe di stare DENTRO quel riquadro preservando le
// proporzioni, quindi non deforma le immagini con orientamenti diversi.
const INLINE_SIZE = '!1024,1024';
const ENLARGED_SIZE = '!1600,1600';

const iiifUrl = (pictureId, size) =>
  `/iiif/2/${pictureId}/full/${size}/0/default.jpg`;

const ImageDecoder = ({ pictureId, altText, className, isCover, isGallery, isCorrelate }) => {
  const [isEnlarged, setIsEnlarged] = useState(false);

  const toggleEnlarged = () => {
    setIsEnlarged(!isEnlarged);
  };

  const preventContextMenu = (event) => {
    event.preventDefault();
  };

  if (!pictureId) {
    return null;
  }

  return (
    <>
    <div className={isCover ? "imageCover" : "image-container"}
      onContextMenu={preventContextMenu}>
      <img
        src={iiifUrl(pictureId, INLINE_SIZE)}
        alt={altText}
        className={className}
        loading="lazy"
        onClick={toggleEnlarged}
      />

      {isEnlarged && (
        <div className="enlarged-image-overlay" onClick={toggleEnlarged}>
          <img
            src={iiifUrl(pictureId, ENLARGED_SIZE)}
            alt={altText}
            className="enlarged-image"
          />
        </div>
      )}
    </div>
    {!isGallery && !isCorrelate && <a href='/credits' className="image-disclaimer">© Credits</a>}
    {isCorrelate && <a href='/credits' className="image-correlate">© Credits</a>}
    </>
  );
};

export default ImageDecoder;
